import { ui } from './class.ui';
import { inputHandler } from "./class.inputhandler";
import { sceneManager } from "./class.scenemanager";
import { palette } from "./class.palette";

class Cassetti {
    constructor(scene, assetsManager, tipo, parentMesh) {
        switch (tipo) {
            // modulo da 120
            case 6:
                this.task = assetsManager.addMeshTask("lineeCassetto", "", "dist/assets/imports/", "cassa120x60/lineecassetti120.babylon");
                break;
            // modulo da 60
            default:
                this.task = assetsManager.addMeshTask("lineeCassetto", "", "dist/assets/imports/", "cassa60/linee_cassetto.babylon");
        }
        this._scene = scene;
        this._parentMesh = parentMesh;
        this._mesh = null;

        this.task.onSuccess = (task) => {

            let materialeCassetti = new BABYLON.StandardMaterial("texture1", this._scene);
            materialeCassetti.diffuseColor = new BABYLON.Color3(0,0,0);

            const cassetti = task.loadedMeshes[0];
            this._mesh = cassetti;

            /*cassetti.isPickable = true;*/

            cassetti.outlineWidth = 0.60;
            cassetti.outlineColor = new BABYLON.Color3(0,0,0);
            cassetti.renderOutline = false;
            cassetti.parent = this._parentMesh;
            cassetti.material = materialeCassetti;

            // Si spacca se cambio il diffuse o lo specular, indagare
            /*cassetti.material.diffuseColor = palette.rgbToBabylon(this._currentColor);
            cassetti.material.specularColor = new BABYLON.Color3(.2, .2, .2);*/

        }
    }

    toggleOutline(status) {
        for (let i = 0; i < this._meshes.length; i++) {
            let triangle = this._meshes[i];
            triangle.renderOutline = status;
        }
    }

    destroy() {
        this._mesh.dispose();
    }

    extractData() {
        let json = [];
        for (let i = 0; i < this._meshes.length; i++) {
            json.push({ "indice": this._meshes[i].name, "colore": palette.rgbToName(this._meshes[i]._currentColor) });
        }

        return json;
    }
}

export default Cassetti;
